import TemplateView from "../TemplateView"

export default class TypeOfWorkNode extends TemplateView {
    constructor({
        typeOfWork,
        selected,
        onClick = () => {}
    }) {
        super();

        this.onClick = onClick

        this.params = {
            id: typeOfWork.id,
            name: typeOfWork.name,
            selected: selected,
        }
    }

    templateHtml() {
        return "<div class='typeOfWorkRow'>" +
               "    <div class='typeLabel ellipsis'><%-name%></div>" +
               "</div>"
    }

    templateModel() {
        return {
            name: this.params.name
        }
    }

    afterRender() {
        this.$el.toggleClass('selected', this.params.selected)
        this.$el.click(() => this.onClick(this.params.id))
    }
}


// WEBPACK FOOTER //
// ./web/js/typesOfWork/TypeOfWorkNode.js